<template>
  <section class="case-creation__step case-creation__patient-information">
    <div class="case-creation__card">
      <div class="case-creation__heading edit-view">
        <div class="title-with-icon">
          <span class="icon">
            <img
              src="@/assets/images/icons/icon-patient-info.svg"
              alt="icon"
              class="img-fluid"
            />
          </span>
          <h3 class="title">Patient Information</h3>
        </div>
      </div>

      <div class="case-creation__body pb-0">
        <div class="vue-data" v-if="getSendOutPatientInformation">
          <el-row :gutter="20">
            <el-col :xl="3" :lg="4" :md="8" :sm="12" :xs="12">
              <div class="input-value view-cases">
                <h4 class="name">First Name</h4>
                <p class="value" v-if="getSendOutPatientInformation.first_name">
                  {{
                    convertToUppercase(getSendOutPatientInformation.first_name)
                  }}
                </p>
                <p class="value" v-else>--</p>
              </div>
            </el-col>
            <el-col :xl="3" :lg="4" :md="8" :sm="12" :xs="12">
              <div class="input-value view-cases">
                <h4 class="name">Middle Name</h4>
                <p
                  class="value"
                  v-if="getSendOutPatientInformation.middle_name"
                >
                  {{
                    convertToUppercase(getSendOutPatientInformation.middle_name)
                  }}
                </p>
                <p class="value" v-else>--</p>
              </div>
            </el-col>
            <el-col :xl="3" :lg="4" :md="8" :sm="12" :xs="12">
              <div class="input-value view-cases">
                <h4 class="name">Last Name</h4>
                <p class="value" v-if="getSendOutPatientInformation.last_name">
                  {{
                    convertToUppercase(getSendOutPatientInformation.last_name)
                  }}
                </p>
                <p class="value" v-else>--</p>
              </div>
            </el-col>
            <el-col :xl="3" :lg="3" :md="8" :sm="12" :xs="12">
              <div class="input-value view-cases">
                <h4 class="name">Gender</h4>
                <p class="value" v-if="getSendOutPatientInformation.gender">
                  {{ getSendOutPatientInformation.gender }}
                </p>
                <p class="value" v-else>--</p>
              </div>
            </el-col>
            <el-col :xl="3" :lg="3" :md="8" :sm="12" :xs="12">
              <div class="input-value view-cases">
                <h4 class="name">Date of Birth</h4>
                <p
                  class="value"
                  v-if="getSendOutPatientInformation.date_of_birth"
                >
                  {{ formatDate(getSendOutPatientInformation.date_of_birth) }}
                </p>
                <p class="value" v-else>--</p>
              </div>
            </el-col>

            <el-col :xl="3" :lg="3" :md="8" :sm="12" :xs="12">
              <div class="input-value view-cases">
                <h4 class="name">EMR</h4>
                <p class="value" v-if="getSendOutPatientInformation.emr">
                  {{ getSendOutPatientInformation.emr }}
                </p>
                <p class="value" v-else>--</p>
              </div>
            </el-col>
            <el-col :xl="3" :lg="4" :md="8" :sm="12" :xs="12">
              <div class="input-value view-cases">
                <h4 class="name">Mobile Number</h4>
                <p class="value" v-if="getSendOutPatientInformation.home_phone">
                  {{ getSendOutPatientInformation.home_phone }}
                </p>
                <p class="value" v-else>--</p>
              </div>
            </el-col>
            <el-col :xl="3" :lg="4" :md="8" :sm="12" :xs="12">
              <div class="input-value view-cases">
                <h4 class="name">Phone Number</h4>
                <p class="value" v-if="getSendOutPatientInformation.work_phone">
                  {{ getSendOutPatientInformation.work_phone }}
                </p>
                <p class="value" v-else>--</p>
              </div>
            </el-col>
            <el-col :xl="3" :lg="4" :md="8" :sm="12" :xs="12">
              <div class="input-value view-cases">
                <h4 class="name">Email</h4>
                <p class="value" v-if="getSendOutPatientInformation.email">
                  {{ getSendOutPatientInformation.email }}
                </p>
                <p class="value" v-else>--</p>
              </div>
            </el-col>
            <el-col :xl="6" :lg="6" :md="8" :sm="12" :xs="12">
              <div class="input-value view-cases">
                <h4 class="name">Address Line 1</h4>
                <p
                  class="value"
                  v-if="getSendOutPatientInformation.address_line_1"
                >
                  {{ getSendOutPatientInformation.address_line_1 }}
                </p>
                <p class="value" v-else>--</p>
              </div>
            </el-col>
            <el-col :xl="6" :lg="6" :md="8" :sm="12" :xs="12">
              <div class="input-value view-cases">
                <h4 class="name">Address Line 2</h4>
                <p
                  class="value"
                  v-if="getSendOutPatientInformation.address_line_2"
                >
                  {{ getSendOutPatientInformation.address_line_2 }}
                </p>
                <p class="value" v-else>--</p>
              </div>
            </el-col>
            <el-col :xl="3" :lg="4" :md="8" :sm="12" :xs="12">
              <div class="input-value view-cases">
                <h4 class="name">Zip</h4>
                <p class="value" v-if="getSendOutPatientInformation.zip">
                  {{ getSendOutPatientInformation.zip }}
                </p>
                <p class="value" v-else>--</p>
              </div>
            </el-col>
            <el-col :xl="3" :lg="4" :md="8" :sm="12" :xs="12">
              <div class="input-value view-cases">
                <h4 class="name">State</h4>
                <p class="value" v-if="getSendOutPatientInformation.state">
                  {{ getSendOutPatientInformation.state }}
                </p>
                <p class="value" v-else>--</p>
              </div>
            </el-col>
            <el-col :xl="3" :lg="4" :md="8" :sm="12" :xs="12">
              <div class="input-value view-cases">
                <h4 class="name">County</h4>
                <p class="value" v-if="getSendOutPatientInformation.county">
                  {{ getSendOutPatientInformation.county }}
                </p>
                <p class="value" v-else>--</p>
              </div>
            </el-col>
            <el-col :xl="3" :lg="4" :md="8" :sm="12" :xs="12">
              <div class="input-value view-cases">
                <h4 class="name">City</h4>
                <p class="value" v-if="getSendOutPatientInformation.city">
                  {{ getSendOutPatientInformation.city }}
                </p>
                <p class="value" v-else>--</p>
              </div>
            </el-col>
            <el-col :xl="3" :lg="4" :md="8" :sm="12" :xs="12">
              <div class="input-value view-cases">
                <h4 class="name">Race</h4>
                <p class="value" v-if="getSendOutPatientInformation.race">
                  {{ getSendOutPatientInformation.race }}
                </p>
                <p class="value" v-else>--</p>
              </div>
            </el-col>
            <el-col :xl="3" :lg="4" :md="8" :sm="12" :xs="12">
              <div class="input-value view-cases">
                <h4 class="name">Ethnicity</h4>
                <p class="value" v-if="getSendOutPatientInformation.ethnicity">
                  {{ getSendOutPatientInformation.ethnicity }}
                </p>
                <p class="value" v-else>--</p>
              </div>
            </el-col>
            <el-col
              :xl="3"
              :lg="4"
              :md="8"
              :sm="12"
              :xs="12"
              v-if="getSendOutPatientInformation.pregnant"
            >
              <div class="input-value view-cases">
                <h4 class="name">Pregnancy</h4>
                <p class="value" v-if="getSendOutPatientInformation.pregnant">
                  {{ getSendOutPatientInformation.pregnant ? "Yes" : "No" }}
                </p>
              </div>
            </el-col>
          </el-row>
        </div>
      </div>
    </div>
  </section>
</template>
<script>
import { mapGetters } from "vuex";
import UserPermissionsHelper from "@/mixins/UserPermissionsHelper";
import AppHelper from "@/mixins/AppHelper";

export default {
  mixins: [UserPermissionsHelper, AppHelper],
  components: {},
  computed: {
    ...mapGetters("sendOuts", ["getReceivedSendOutInformation"]),

    getSendOutPatientInformation() {
      if (
        this.getReceivedSendOutInformation &&
        Object.keys(this.getReceivedSendOutInformation).length > 0 &&
        this.getReceivedSendOutInformation.patient_info
      ) {
        return this.getReceivedSendOutInformation.patient_info;
      }
      return null;
    },
  },

  data() {
    return {};
  },
  methods: {},
};
</script>

<style lang="scss" scoped>
.err {
  color: #c14e4e;
}
</style>
